import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import favicon16 from "../img/favicon/16x16.png";
import favicon32 from "../img/favicon/32x32.png";
import favicon64 from "../img/favicon/64x64.png";

// Styles
import "../scss/main.scss";

export default class IndexLayout extends React.Component {
  static propTypes = {
    children: PropTypes.func
  };

  render() {
    return (
      <div>
        <Helmet
          title="Bernie Graham"
          meta={[
            {
              name: "description",
              content:
                "Bernie Graham - Sr. Software Engineer and Engineering Manager"
            },
            {
              name: "keywords",
              content: "Scala, go, golang, python, aws"
            }
          ]}
          link={[
            {
              rel: "icon",
              type: "image/png",
              sizes: "16x16",
              href: `${favicon16}`
            },
            {
              rel: "icon",
              type: "image/png",
              sizes: "32x32",
              href: `${favicon32}`
            },
            {
              rel: "shortcut icon",
              type: "image/png",
              href: `${favicon64}`
            }
          ]}
        />
        {this.props.children()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js